import React from 'react';
import PropTypes from 'prop-types';
import BillingSenderAddForm from "./BillingSenderAddForm";
import {withRouter} from "react-router-dom";

const BillingSenderAddRoute = ({history}) => {
    const handleSubmit = (data => history.push(`/billing/senders/${data.id}`));

    return (
        <div style={{maxWidth: 800}}>
            <BillingSenderAddForm
                onSubmit={handleSubmit}
            />
        </div>
    );
};

BillingSenderAddRoute.propTypes = {
    onSubmit: PropTypes.func,
};

export default withRouter(BillingSenderAddRoute);